
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import SlideContainer from 'components/SlideContainer'
import VectorImage from 'components/VectorImage'
import {closeModal} from 'redux/modules/ui/modal/actions'
import wrenchImage from 'components/Icon/images/wrench.svg'

export class HelpView extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func
  }

  render() {
    const {closeModal} = this.props

    return (
      <SlideContainer
        className='help-view'
        title='Contact Support'
        subtitle='Need help? Send us a message.'
        icon={wrenchImage}
        onCloseModal={closeModal}
      >
        <div className='help-view_content'>
          <div className='help-view_item'>
            <div>Email</div>
            <a href='mailto:marketing-cloud@sportradar.com'>marketing-cloud@sportradar.com</a>
          </div>
        </div>
      </SlideContainer>
    )
  }

  renderImage() {
    return (
      <div className='help-view_image'>
        <VectorImage
          width='50px'
          height='71px'
          className='help-view_image_icon'
          source={wrenchImage}
        />
      </div>
    )
  }
}

export default connect(null, {
  closeModal
})(HelpView)



// WEBPACK FOOTER //
// ./client/modals/HelpView/index.js